module.exports = "/img/23.5c5c7e.webp";